import { createLucideIcon } from 'lucide-react'

const StickyNotePlus = createLucideIcon('sticky-note-plus', [
  ['path', { d: 'M12 8v4' }],
  ['path', { d: 'M10 10h4' }],
  ['path', { d: 'M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z' }],
  ['path', { d: 'M15 3v4a2 2 0 0 0 2 2h4' }]
])

export default StickyNotePlus
